import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConfermaEliminaDocConservazioneComponent } from './conferma-elimina-doc-conservazione';

export const ConfermaEliminaDocConservazioneModule: string = ng
    .module('archiSmall.components.confermaEliminaDocConservazioneModule', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('confermaEliminaDocConservazioneComponent', ConfermaEliminaDocConservazioneComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/conferma-elimina-doc-conservazione/conferma-elimina-doc-conservazione.module.ts